import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  home: {
    width: 100,
    height: 100,
    d: `M98.34,46.4,50.57,4.9a.86.86,0,0,0-1.14,0L1.66,46.4a.87.87,0,0,0,.57,
    1.53H12.3V87a8.34,8.34,0,0,0,8.34,8.34H33.13A8.35,8.35,0,0,0,41.47,
    87V59.77a.34.34,0,0,1,.33-.34H58.26a.34.34,0,0,1,.34.34V87a8.33,8.33,0,
    0,0,8.33,8.34H80.36c4.61,0,7.34-3.74,7.34-8.34V47.93H97.77A.87.87,0,0,0,98.34,46.4Z`,
  },
});
